export default __webpack_public_path__ + "static/logos-cc10bd72bdbe1d6a68449451ba09db46.png";